import _ from 'underscore';
import { AlertCenter } from '@bingads-webui/alert-center';

const alertLevel = {
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
  success: 'Confirmation',
};

export class CcuiAlertCenter extends AlertCenter {
  /**
   * Note: The new alert banner will override the one with same id,
   * so when you want to use functions below,
   * please make sure you only need one banner for one call or show the first one is as expected.
   * Otherwise please customize in your feature
   * @param {Object} i18n - The i18n object that contains legacy keys Alert_CarouselPagination and Button_Got_it.
   */
  constructor({ i18n } = {}) {
    super({ useCarouselForErrors: true, i18n });
  }

  show(alert, id) {
    return super.show({
      hasIcon: true,
      ...alert,
    }, id);
  }

  appendError(errors, id) {
    if (_.isArray(errors) && !_.isEmpty(errors) && errors[0].Message) {
      this.appendErrorMessage(errors[0].Message, id);
    }
  }

  appendWarning(warnings, id) {
    if (_.isArray(warnings) && !_.isEmpty(warnings) && warnings[0].Message) {
      this.appendWarningMessage(warnings[0].Message, id);
    }
  }

  appendInfo(info, id) {
    if (_.isObject(info) && info.Message) {
      this.appendInfoMessage(info.Message, id);
    }
  }

  appendSuccess(confirmation, id) {
    if (_.isObject(confirmation) && confirmation.Message) {
      this.appendSuccessMessage(confirmation.Message, id);
    }
  }

  appendInfoMessage(infoMessage, id) {
    this.show({
      level: alertLevel.info,
      dismissible: false,
      id,
      message: infoMessage,
    }, id);
  }

  appendWarningMessage(warningMessage, id) {
    this.show({
      level: alertLevel.warning,
      dismissible: true,
      id,
      message: warningMessage,
    }, id);
  }

  appendErrorMessage(errorMessage, id) {
    this.show({
      level: alertLevel.error,
      dismissible: false,
      id,
      message: errorMessage,
    }, id);
  }

  appendSuccessMessage(confirmationMessage, id) {
    this.show({
      level: alertLevel.success,
      dismissible: true,
      id,
      message: confirmationMessage,
    }, id);
  }
}

